/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/prefer-as-const */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useTypedDispatch } from '../../redux/dispatchActionTypes/dispatchAndThunkActionTypes';
import { Button, Divider, IconButton, MobileStepper, Paper, useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import Snackbar from '@mui/material/Snackbar';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPanelsAndEstates } from '../../redux/actions/panelEstateActions';
import { deleteSpecificEstate, deleteSpecificPanel } from '../../redux/actions/specificPanelActions';
import { DeleteEstateProps } from './DeleteEstateModalTypes';
import { fetchEstates, fetchPanels, fetchUnAssignedPanels, setEstate } from '../../redux/actions/esateActions';
import { useTranslation, Trans } from 'react-i18next';
import { useNavigate } from 'react-router';


const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  backgroundColor: 'background.paper',
  boxShadow: 20,
  p: 0,
};

export default function DeleteEstateModal({ estatePage, open, setOpen, selectedEstateId, selectedEstateName,pathArray,setPathArray}: DeleteEstateProps): JSX.Element {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.down('md'));
  const [activeStep, setActiveStep] = React.useState(0);
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [snackSet, setSnackSet] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [count, setCount] = React.useState(0);
  const { specificEstate } = useSelector((state: any) => state.estateReducer);
  const { deleteEstateStatus } = useSelector((state: any) => state.specificPanelAndEstateReducer);
  const dispatch = useTypedDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();  
  const dispatchEstate = useDispatch()

  const handleClose = () => {
    setOpen(false);
    setActiveStep(0);
  }

  const fetching = async() => {
    await dispatch(fetchEstates(specificEstate?.ID))
    await dispatch(fetchPanels(specificEstate?.ID))
    await dispatch(fetchUnAssignedPanels(specificEstate?.ID))
}

  React.useEffect(() => {
   if(snackSet) 
    {
      if(deleteEstateStatus !== 0){
      setSnackOpen(true);
      if (deleteEstateStatus !== 204) {
        setMessage(`${t('msg_deleteEstate_error')}`);
      } else {
        setMessage(`${t('msg_estate_deleted')}`);
        if(estatePage){
          fetching()
        }
        else{
        dispatch(fetchPanelsAndEstates())
        }
      }
    }
    setSnackSet(false)
  }
  }, [count])

  const handleDelete = async() => {
    await dispatch(deleteSpecificEstate(selectedEstateId));
    setSnackSet(true)
    setCount((prev) => prev + 1)
    setOpen(false);    
    const path = pathArray[pathArray.length - 2];
    setPathArray(pathArray.slice(0,pathArray.length - 1))
    if(pathArray?.length>1){
      dispatchEstate(setEstate(path));
      navigate(-1);
    }else{
      navigate(-1);
    }
  }

  const handleSnackClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackOpen(false);
  };

  const action = (
    <React.Fragment>
      <Button color="primary" size="small" onClick={handleSnackClose}>
      {t('lbl_close')}
      </Button>
    </React.Fragment>
  );

  return (
    <div>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} >
          <Paper elevation={0} sx={{ pb: 1 }}>
            <Typography sx={{ pt: 2, pl: 2, pb: 2 }} variant='h6'>{t('lbl_delete_estate')} {selectedEstateName}</Typography>
            <Typography sx={{ pl: 2, pb: 4, pt: 0 }} >{t('msg_delete_estate')} “{selectedEstateName}”? {t('msg_no_action_revert')}</Typography>
          </Paper>
          <Divider />
          <Paper >
            <MobileStepper
              variant="dots"
              steps={0}
              position="static"
              activeStep={activeStep}
              sx={{ maxWidth: 400, flexGrow: 1, paddingTop: 2, paddingBottom: 2, paddingLeft: 3, paddingRight: 3, backgroundColor: 'inherit' }}
              nextButton={
                <Button size="medium" disableElevation sx={{ backgroundColor: '#CA3C3D' }} variant='contained' onClick={handleDelete}>
                  {t('lbl_delete')}
                </Button>
              }
              backButton={
                <Button size="small" variant='outlined' onClick={handleClose}  >
                  {t('btn_cancel')}
                </Button>
              }
            />
          </Paper>
        </Box>
      </Modal>
      <Snackbar
        open={snackOpen}
        autoHideDuration={6000}
        onClose={handleSnackClose}
        message={message}
        action={action}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      />
    </div>
  );
}
